export default {
  home: '首页',
  login: '登录',
  system_setting: '系统配置',
  menu_setting: '菜单维护',
  user_setting: '用户管理',
  auth_setting: '权限管理',
  logs: '操作日志',
  apps_setting: '应用接入',
  apps_group: '应用分组',
  apps_list: '应用列表',
  interface_setting: '接口设置',
  interface_group: '接口分组',
  interface_list: '接口列表',
  add_button: '新增',
  find_button: '查询',
  refresh_button: '刷新',
  delete_button: '删除',
  edit_button: '编辑',
  open_choose: '启用',
  close_choose: '禁用',
  show_choose: '显示',
  hide_choose: '隐藏',
  interface_request: '请求参数',
  interface_response: '返回参数',
  user_center: '个人中心',
  wiki_list: '文档中心',
  wiki_error: '错误码',
  wiki_calculation: '算法详解',
  wiki_login: '文档登录',

  /**菜单**/
  用户登录:'用户登录',
  用户登出:'用户登出',
  系统管理:'系统管理',
  菜单维护:'菜单维护',
  菜单状态修改:'菜单状态修改',
  新增菜单:'新增菜单',
  编辑菜单:'编辑菜单',
  菜单删除:'菜单删除',
  角色管理:'角色管理',
  获取当前组的全部用户:'获取当前组的全部用户',
  用户状态修改:'用户状态修改',
  新增用户:'新增用户',
  用户编辑:'用户编辑',
  用户删除:'用户删除',
  权限管理:'权限管理',
  权限组状态编辑:'权限组状态编辑',
  从指定组中删除指定用户:'从指定组中删除指定用户',
  新增权限组:'新增权限组',
  权限组编辑:'权限组编辑',
  删除权限组:'删除权限组',
  获取全部已开放的可选组:'获取全部已开放的可选组',
  获取组所有的权限列表:'获取组所有的权限列表',
  应用接入:'应用接入',
  应用管理:'应用管理',
  应用状态编辑:'应用状态编辑',
  获取AppIdAppSecret接口列表应用接口权限细节:'获取AppIdAppSecret接口列表应用接口权限细节',
  新增应用:'新增应用',
  编辑应用:'编辑应用',
  删除应用:'删除应用',
  接口管理:'接口管理',
  接口维护:'接口维护',
  接口状态编辑:'接口状态编辑',
  获取接口唯一标识:'获取接口唯一标识',
  添加接口:'添加接口',
  编辑接口:'编辑接口',
  删除接口:'删除接口',
  获取接口请求字段:'获取接口请求字段',
  获取接口返回字段:'获取接口返回字段',
  添加接口字段:'添加接口字段',
  上传接口返回字段:'上传接口返回字段',
  编辑接口字段:'编辑接口字段',
  删除接口字段:'删除接口字段',
  接口分组:'接口分组',
  添加接口组:'添加接口组',
  编辑接口组:'编辑接口组',
  删除接口组:'删除接口组',
  获取全部有效的接口组:'获取全部有效的接口组',
  接口组状态维护:'接口组状态维护',
  应用分组:'应用分组',
  添加应用组:'添加应用组',
  编辑应用组:'编辑应用组',
  删除应用组:'删除应用组',
  获取全部可用应用组:'获取全部可用应用组',
  应用组状态编辑:'应用组状态编辑',
  菜单列表:'菜单列表',
  用户列表:'用户列表',
  权限列表:'权限列表',
  应用列表:'应用列表',
  应用分组列表:'应用分组列表',
  接口列表:'接口列表',
  接口分组列表:'接口分组列表',
  日志管理:'日志管理',
  获取操作日志列表:'获取操作日志列表',
  删除单条日志记录:'删除单条日志记录',
  刷新路由:'刷新路由',
  文件上传:'文件上传',
  更新个人信息:'更新个人信息',
  刷新AppSecret:'刷新AppSecret',
  获取用户信息:'获取用户信息',
  编辑权限细节:'编辑权限细节',
  获取用户有权限的菜单:'获取用户有权限的菜单',
  系统支撑:'系统支撑',
  用户管理:'用户管理',
  会员列表:'会员列表',
  在线会员:'在线会员',

}
